import { render } from "./TablePanel.vue?vue&type=template&id=0650de0b"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"
script.render = render

export default script